import { I18nUtils } from '@medable/i18n-core';
import { getApiInstance } from '../../../helpers/api.helpers';
import { getApiLocale } from '../../../helpers/pseudo_locale.helpers';
const VISIT_EVENTS_PAGE_SIZE = 100;
const visitEventsWhere = (participantId) => ({
    c_public_user: participantId,
    type: 'c_visit_event',
});
export const fetchSiteActivities = async ({ environment, visit, participantId, site, locale, }) => {
    if (!environment || (visit && !visit.c_group)) {
        return [];
    }
    const responseSiteTasks = await getApiInstance(environment, locale).get(`/v2/routes/c_sites/${site?._id}/c_public_users/${participantId}/c_groups/${visit?.c_group}/c_task_assignments`, {
        headers: {
            'Accept-Language': I18nUtils.cortexToI18nFormat(getApiLocale(locale) || locale),
        },
        params: {
            dedupeByAssignment: true,
        },
    });
    return responseSiteTasks?.data.data;
};
export const fetchParticipantActivities = async ({ environment, participantId, locale }) => {
    if (!environment || !participantId) {
        return [];
    }
    const responseParticipantActivities = await getApiInstance(environment, locale).get(`/v2/routes/c_public_users/${participantId}/c_events`, {
        params: {
            paths: [
                'c_start',
                'c_end',
                'c_task.c_name',
                'c_task.c_type',
                'c_task.c_observation_type',
                'c_completed',
                'type',
                'c_missed',
                'c_task_assignment.c_schedule_rules',
                'c_auto_start',
                'c_canceled',
                'c_title',
                'c_timezone',
                'c_task_assignment.c_order',
                'c_order',
                'c_visit_id',
                'c_visit_name',
                'c_enforce_order',
                'c_task_assignment.c_visit',
                'c_modality',
            ],
            include: ['c_task_response'],
        },
    });
    if (responseParticipantActivities?.data.generating) {
        return [{ generating: true }];
    }
    return responseParticipantActivities?.data.data;
};
export const fetchVisitEvent = async ({ environment, visitId, participantId }) => {
    if (!environment || !participantId) {
        return [];
    }
    const responseVisitEventDetails = await getApiInstance(environment).get('/v2/c_events', {
        params: {
            where: {
                c_schedule_visit: visitId,
                c_public_user: participantId,
                type: 'c_visit_event',
            },
        },
    });
    const visitEvent = responseVisitEventDetails?.data.data.find((visitEvent) => visitEvent?.c_schedule_visit?._id === visitId);
    return visitEvent || null;
};
export const fetchParticipantVisitEvents = async ({ environment, participantId, locale, }) => {
    if (!environment || !participantId) {
        return [];
    }
    const api = getApiInstance(environment, locale);
    const allVisitEvents = [];
    let skip = 0;
    while (true) {
        const response = await api.get('/v2/c_events', {
            params: {
                where: visitEventsWhere(participantId),
                limit: VISIT_EVENTS_PAGE_SIZE,
                skip,
            },
        });
        const pageEvents = response?.data?.data ?? [];
        allVisitEvents.push(...pageEvents);
        if (pageEvents.length < VISIT_EVENTS_PAGE_SIZE) {
            break;
        }
        skip += VISIT_EVENTS_PAGE_SIZE;
    }
    return allVisitEvents;
};
